import { render } from "./YWBK.vue?vue&type=template&id=6985e678"
import script from "./YWBK.vue?vue&type=script&lang=js"
export * from "./YWBK.vue?vue&type=script&lang=js"

import "./YWBK.vue?vue&type=style&index=0&id=6985e678&lang=scss"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__